<template>
  <div>
    <div v-if="account.id_account_type == '4'" class="row">
      <div class="col-12 col-lg-6">
        <h5>Limite</h5>
        <p>{{ formatValue(account.limit) }}</p>
      </div>
      <div class="col-12 col-lg-6">
        <h5>Limite disponível</h5>
        <p>{{ formatValue(account.limit + totalBalance) }}</p>
      </div>
      <div class="col-12 col-lg-6">
        <h5>Data do fechamento</h5>
        <p>{{ account.closing_day }}</p>
      </div>
      <div class="col-12 col-lg-6">
        <h5>Vencimento</h5>
        <p>{{ account.due_day }}</p>
      </div>
    </div>
    <div class="separator" />
    <div class="row">
      <div v-if="account.id_bank_data" class="col-12 col-lg-6">
        <h5>Instituição</h5>
        <p>{{ account.id_bank_data.name }}</p>
      </div>
      <div v-if="account.id_account_type_data" class="col-12 col-lg-6">
        <h5>Tipo de conta</h5>
        <p>{{ account.id_account_type_data.label }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6">
        <h5>Agência</h5>
        <p>{{ account.account_agency }}</p>
      </div>
      <div class="col-12 col-lg-6">
        <h5>Número da conta</h5>
        <p>{{ account.account_number }}</p>
      </div>
      <div v-if="account.id_account_type == '4'" class="col-12 col-lg-6 pay-box">
        <button class="btn-pay" @click="emitModal('Pagar Fatura')">
          Pagar fatura
        </button>
      </div>
      <div class="col-12 col-lg-6 pay-box">
        <button class="btn-pay" @click="emitModal('Upload')">
          Upload de lançamentos (formato OFX)
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    account: Object,
    formatValue: Function,
    totalBalance: String,
  },
  data() {
    return {};
  },
  computed: {},
  created() { },

  methods: {
    emitModal(value) {
      this.$emit("openModal", value);
    },
  },
};
</script>
<style lang="scss" scoped>
.pay-box {
  text-align: center;

  .btn-pay {
    background-color: transparent;
    width: auto;
    padding: 10px;
    border: 1px solid #cb5540;
    border-radius: 4px;
    color: #cb5540;

    &:hover {
      transform: scale(1.05);
      font-weight: bold;
    }
  }
}

.bills {
  h2 {
    color: #fff;
    font-size: 18px;
    margin: 0;
  }

  h3 {
    color: #fff;
    font-size: 15px;
    margin: 0;
  }

  h4 {
    color: #fff;
    font-size: 13px;
    margin: 0;
  }
}

.title-account {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  h1 {
    color: #fff;
    font-size: 18px;
    margin: 0;
  }
}

h5 {
  color: #bdbaba;
  font-size: 12px;
  margin: 0;
  font-weight: 300;
}

.header-account {
  display: flex;
  justify-content: space-between;
}

.return-icon {
  cursor: pointer;
  user-select: none;

  &:hover {
    transform: scale(1.2);
  }
}

.edit-btn {
  display: flex;
  align-items: center;
  color: #fff;

  p {
    margin: 0;
  }

  i {
    margin-right: 5px;
  }
}
</style>
